import Circle from "./circle"

const CLEAR_PADDING = 64;

/** how much of the image to retain each frame */
const BLUR_ALPHA = 0.92;

class LogoCircles
{
    constructor(ctx, x, y, size, config)
    {
        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.size = size;

        this.config = config;

        const numCircles = config.length;

        this.circles =  new Array(numCircles);

        const halfSize = size/2;

        for(let i=0; i < numCircles; i++)
        {
            this.circles[i] = new Circle(ctx, x + halfSize, y + halfSize, size * 0.6666, config[i]);
        }

        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
    }

    onMouseUp()
    {
        const numCircles = this.circles.length;
        for(let i=0; i < numCircles; i++)
        {
            this.circles[i].isDragged = false;
        }
    }

    onMouseDown(mouseX, mouseY)
    {

        const numCircles = this.circles.length;
        for(let i=0; i < numCircles; i++)
        {
            const circle = this.circles[i];
            if (circle.minDistanceIndex > 0)
            {
                const { data, minDistanceIndex } = circle;
                
                circle.updateMouse(mouseX, mouseY);
                circle.isDragged = true;
                circle.dragOffsetX = data[minDistanceIndex    ] - mouseX;
                circle.dragOffsety = data[minDistanceIndex + 1] - mouseY;
            }
        }
    }

    onMouseMove(mouseX, mouseY)
    {
        const numCircles = this.circles.length;
        for(let i=0; i < numCircles; i++)
        {
            this.circles[i].updateMouse(mouseX, mouseY);
        }
    };


    update(stats)
    {
        const numCircles = this.circles.length;
        for(let i=0; i < numCircles; i++)
        {
            this.circles[i].update(stats);
        }
    }

    clear(stats)
    {
        const { ctx } = this;
        const { aabb, terrainY } = stats;

        ctx.save();
        ctx.globalAlpha = BLUR_ALPHA;
        ctx.globalCompositeOperation="copy";

        const x = (aabb.minX - CLEAR_PADDING)|0;
        const y = (aabb.minY - CLEAR_PADDING)|0;
        const width = (aabb.maxX - aabb.minX + CLEAR_PADDING * 2)|0;
        const height = (aabb.maxY- aabb.minY + CLEAR_PADDING * 2)|0;

        if (width > 0 && height > 0)
        {
            ctx.drawImage(ctx.canvas, x, y, width, height, x, y,width, height);
        }

        ctx.restore();

        aabb.reset();

    }

    render(stats)
    {

        const cpLine = stats.cpLine;
        if (cpLine)
        {
            const { ctx } = this;

            ctx.lineWidth = 1;
            ctx.strokeStyle = "#f08";
            for (let i = 0; i < cpLine.length; i += 8)
            {
                ctx.beginPath();
                ctx.moveTo(cpLine[i    ], cpLine[i + 1]);
                ctx.lineTo(cpLine[i + 2], cpLine[i + 3]);
                ctx.stroke();
            }
            ctx.strokeStyle = "#80f";
            for (let i = 0; i < cpLine.length; i += 8)
            {
                ctx.beginPath();
                ctx.moveTo(cpLine[i + 4], cpLine[i + 5]);
                ctx.lineTo(cpLine[i + 6], cpLine[i + 7]);
                ctx.stroke();
            }
        }

        const numCircles = this.circles.length;
        for(let i=0; i < numCircles; i++)
        {
            this.circles[i].render(stats);
        }


    }
}

export default LogoCircles;



// WEBPACK FOOTER //
// ./src/circles/index.js